import { HTMLAttributes } from "react"

export default function Lodash(props: HTMLAttributes<SVGElement>) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
      <path d="M0 3.213h5.966v39.593H29.56v4.88H0zm48.162 10.74c-6.102-.08-12.203 3.797-14.102 9.68-2.712 6.78-1.464 15.295 3.85 20.474 5.153 4.285 12.908 4.6 18.712 1.573 3.986-2.115 6.508-6.32 7.05-10.74.705-4.6.353-9.654-1.898-13.83-2.658-4.447-7.864-7.322-13.017-7.132l-.597-.08zm.542 4.72c4.475 0 8.488 3.417 9.22 7.8 1.356 4.963.542 11.037-3.525 14.536-3.797 3.092-9.898 2.658-13.017-1.166-3.797-4.068-3.797-10.305-1.844-15.186 1.356-3.525 4.963-6.047 8.76-5.966h.488z" />
      <path d="M0 54.007h64v6.78H0z" fill="#3492ff" />
    </svg>
  )
}
